module.exports = __webpack_public_path__ + "img/img3.81ac9a80.png";